import React from 'react'
import moment from 'moment';

interface StatusCircleProps {
    dataInicial: Date;
    dataFormatada: string;
    intermediario: number
}

const StatusCircleTresCores = ({ dataInicial, dataFormatada, intermediario }: StatusCircleProps) => {
    let backgroundColorResult = '#228800'
    if (moment(dataInicial).diff(moment(), 'days') <= intermediario) backgroundColorResult = '#ddbb00'
    if (moment(dataInicial).diff(moment(), 'days') <= 0) backgroundColorResult = '#EE4E4E'
    return (
        (dataInicial ? (
            <>
                <div className="status-circle">
                    <span
                        style={{
                            content: ' ',
                            borderRadius: '50%',
                            width: '10px',
                            height: '10px',
                            backgroundColor: backgroundColorResult,
                            display: 'inline-block',
                            padding: '5px',
                        }}></span>
                    <span
                        style={{
                            padding: '5px',
                        }}>
                        {dataFormatada}
                    </span>
                </div>

            </>) : (<> </>))
    );
}

export default StatusCircleTresCores